import { ExternalAvtalegiro, ExternalAvtalegiroRequest } from '../../generated-types';

export default (avtalegiro: ExternalAvtalegiro): ExternalAvtalegiroRequest => ({
    id: avtalegiro.id,
    creditorAccountNumber: avtalegiro.creditorAccount,
    creditorName: avtalegiro.creditorName,
    kid: avtalegiro.kid,
    mandateBank: avtalegiro.mandateBank,
    maximumAmount: avtalegiro.maximumAmount,
    note: avtalegiro.note,
    oldDebitorAccount: avtalegiro.debitorAccountNumber,
    maxMonthlyAmount: avtalegiro.maxMonthlyAmount,
});
